import { Card } from '@cmsgov/ds-medicare-gov'
import { parse } from 'date-fns'
import { useTranslation } from 'react-i18next'

type Props = {
  title: string
  name: string
  effectiveDate: string
  disenrollmentDate: string
}
export default function PlanHistoryCard (props: Props) {
  const { t } = useTranslation('accountHome', {
    keyPrefix: 'planHistory.planHistoryCard'
  })
  const { name, title, effectiveDate, disenrollmentDate } = props

  const parsedEffectiveDate = parse(effectiveDate, 'yyyy-MM-dd', new Date())
  const formattedEffectiveDate = new Intl.DateTimeFormat('en-US').format(
    parsedEffectiveDate
  )

  const parsedDisenrollmentDate = parse(
    disenrollmentDate,
    'yyyy-MM-dd',
    new Date()
  )
  const formattedDisenrollmentDate = new Intl.DateTimeFormat('en-US').format(
    parsedDisenrollmentDate
  )

  return (
    <Card className="ds-u-padding--3">
      <div className="ds-u-md-display--flex my-u-width--full my-u-gap--8">
        <div className="ds-u-display--flex ds-u-flex-direction--column my-u-md-basis--6/12">
          <div className="ds-text-body--md ds-u-margin-bottom--0">{title}</div>
          <div className="ds-text-body--lg ds-u-font-weight--semibold">
            <>{name}</>
            {/* TODO - Add Plan ID, if we have it (probably pbpid) */}
          </div>
        </div>

        <div className="ds-u-display--flex ds-u-flex-direction--column my-u-md-grow--1">
          <div className="ds-text-body--md ds-u-margin-bottom--0">
            {t('coverageDates')}
          </div>
          <div className="ds-text-body--lg ds-u-font-weight--semibold my-u-whitespace-nowrap">
            {`${formattedEffectiveDate} – ${formattedDisenrollmentDate}`}
          </div>
        </div>
      </div>
    </Card>
  )
}
